import { channelColors } from '@buffer-mono/popcorn'
import type { Service } from '~publish/gql/graphql'

export function isFacebookGroup(channel: {
  service: string
  serverUrl?: string | null
}): boolean {
  return (
    (channel.service === 'facebook' &&
      channel.serverUrl?.startsWith('https://www.facebook.com/groups')) ??
    false
  )
}

const channelServiceMap: Record<Service, string> = {
  instagram: 'Instagram',
  threads: 'Threads',
  linkedin: 'LinkedIn',
  bluesky: 'Bluesky',
  facebook: 'Facebook',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  mastodon: 'Mastodon',
  pinterest: 'Pinterest',
  googlebusiness: 'Google Business Profile',
  twitter: 'Twitter / X',
  startPage: 'Start Page',
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const channelServices = Object.keys(channelServiceMap) as Service[]

export function getChannelName(service: Service): string {
  return channelServiceMap[service]
}

export function getChannelColor(service: Service): string {
  return channelColors[service]
}
